import React from "react";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails, serviceActions } from "../assets/serviciosDetalle";
import ServiceCta from "../components/ServiceCta";
import ServiceHero from "../components/ServiceHero";
import ServiceSection from "../components/ServiceSection";
import ServiceSectionHead from "../components/ServiceSectionHead";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["proyectos-tecnologicos"];
const [introSection, ...remainingSections] = service.sections;
const projectNavTheme = {
    ...serviciosNavTheme,
    primary: "#0f4c81",
    primaryDark: "#0c3e69",
    primaryLight: "#bfd8f0",
    pale: "rgba(15, 76, 129, 0.08)",
};

export default function ProyectosTecnologicosEnSalud() {
    return (
        <div className="servicios servicio-detalle service-page-proyectos-tecnologicos">
            <SiteNavbar activeSection="servicios" ctaLabel="Contactar" ctaHref={serviceActions.homeContact} navTheme={projectNavTheme} />
            <ServiceHero service={service} hideStats />

            <section className={`service-detail-section ${introSection.variant ? `service-section-${introSection.variant}` : ""}`}>
                <div className="service-detail-inner">
                    <ServiceSectionHead section={introSection} />
                    <div className="service-split service-split-with-stats">
                        <div className="service-copy-block">
                            {introSection.paragraphs.map((paragraph) => (
                                <p key={paragraph}>{paragraph}</p>
                            ))}
                        </div>
                        <aside className="service-project-stats">
                            {service.stats.map(([value, label]) => (
                                <div className="service-project-stat" key={value}>
                                    <strong>{value}</strong>
                                    <span>{label}</span>
                                </div>
                            ))}
                        </aside>
                    </div>
                </div>
            </section>

            {remainingSections.map((section) => (
                <ServiceSection key={`${section.label}-${section.title}`} section={section} />
            ))}
            <ServiceCta service={service} />
            <SiteFooter/>
        </div>
    );
}
